import Controller from "./captainInRideControls.controller";
import template from "./captainInRideControls.html";

const captainInRideControls = {
  template,
  controller: Controller,
  bindings: {
    cityId: "<",
    checkingConfig: "<",
  },
};

export default captainInRideControls;



// WEBPACK FOOTER //
// ./src/components/captainInRideControls/captainInRideControls.component.js